/* @flow */
import React from 'react';

import { FaqService } from 'frilans-finans';

import FaqPage from './faq-page';
import { Spinner } from 'components';

class Faq extends React.Component {

  constructor (props) {
    super(props);

    this.state = {
      faqs: [],
      pendingRequest: null
    };
  }

  componentDidMount () {
    this.fetch();
  }

  componentWillUnmount () {
    if (this.state.pendingRequest && this.state.pendingRequest.cancel) {
      this.state.pendingRequest.cancel();
    }
  }

  fetch () {
    let pendingRequest;

    pendingRequest = FaqService.get();
    pendingRequest.promise
      .then((response) => {
        this.setState({
          faqs: response
        });
      })
      .catch((err) => {
        console.error(err);
      });

    this.setState({
      pendingRequest: pendingRequest
    });
  }

  render () {
    return this.state.faqs.length > 0 ? <FaqPage faqs={this.state.faqs} /> : <Spinner size={100} />;
  }
}

export default Faq;



/** WEBPACK FOOTER **
 ** ./src/views/faq/faq.js
 **/